import './SectionPage.scss';

import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import { Phone } from '../components/Icons';
import { SITE, SectionPageConfig } from '../routes';

type Props = { page: SectionPageConfig; children: React.ReactNode };

const d = (ms: number) => ({ '--delay': `${ms}ms` } as React.CSSProperties);

/** A standalone page for one homepage section: its own H1, intro, SEO tags and a closing quote band. */
export function SectionPage({ page, children }: Props) {
  useSeo({ title: page.title, description: page.description, canonical: SITE + page.to });
  const isContact = page.id === 'contact';

  return (
    <main className="sp">
      <section className="sp__hero on-dark">
        <div className="sp__glow" aria-hidden="true" />
        <div className="container">
          <nav className="sp__crumbs reveal" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">/</span>
            <span>{page.text}</span>
          </nav>
          <span className="eyebrow reveal" style={d(60)}>
            {page.eyebrow}
          </span>
          <h1 className="reveal" style={d(120)}>
            {page.h1}
          </h1>
          <p className="sp__intro reveal" style={d(180)}>
            {page.intro}
          </p>
          {!isContact && (
            <div className="sp__cta reveal" style={d(240)}>
              <Link className="btn btn--blue" to="/contact">
                Get a free quote
              </Link>
              <a className="btn btn--glass" href="tel:+16043655225">
                <Phone /> (604) 365-5225
              </a>
            </div>
          )}
        </div>
      </section>

      {children}

      {!isContact && (
        <section className="section sp__band on-dark">
          <div className="sp__glow" aria-hidden="true" />
          <div className="container">
            <h2 className="reveal">Ready for a fresh coat?</h2>
            <p className="lede reveal" style={d(80)}>
              Free, no-obligation quotes across Delta and the Lower Mainland. We follow up within one business day.
            </p>
            <div className="sp__cta reveal" style={d(160)}>
              <Link className="btn btn--blue" to="/contact">
                Request a quote
              </Link>
              <a className="btn btn--white" href="tel:+16043655225">
                <Phone /> (604) 365-5225
              </a>
            </div>
          </div>
        </section>
      )}
    </main>
  );
}
